import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute(
  "/_auth/admin/billing/invoices/preview/$orgId",
)({
  params: {
    parse: (params) => ({ orgId: Number(params.orgId) }),
  },
});
